"use client";
import { rem } from "../../core/utils/units-converters/rem.mjs";
import { getRadius, getSize } from "../../core/utils/get-size/get-size.mjs";
import { createVarsResolver } from "../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { useStyles } from "../../core/styles-api/use-styles/use-styles.mjs";
import { polymorphicFactory } from "../../core/factory/polymorphic-factory.mjs";
import { UnstyledButton } from "../UnstyledButton/UnstyledButton.mjs";
import { CloseIcon } from "./CloseIcon.mjs";
import CloseButton_module_default from "./CloseButton.module.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/CloseButton/CloseButton.tsx
const defaultProps = { variant: "subtle" };
const varsResolver = createVarsResolver((_, { size, radius, iconSize }) => ({ root: {
	"--cb-size": getSize(size, "cb-size"),
	"--cb-radius": radius === void 0 ? void 0 : getRadius(radius),
	"--cb-icon-size": rem(iconSize)
} }));
const CloseButton = polymorphicFactory((_props) => {
	const props = useProps("CloseButton", defaultProps, _props);
	const { iconSize, children, vars, radius, className, classNames, style, styles, unstyled, "data-disabled": dataDisabled, disabled, variant, icon, mod, attributes, __staticSelector, ...others } = props;
	const getStyles = useStyles({
		name: __staticSelector || "CloseButton",
		props,
		className,
		style,
		classes: CloseButton_module_default,
		classNames,
		styles,
		unstyled,
		attributes,
		vars,
		varsResolver
	});
	return /* @__PURE__ */ jsxs(UnstyledButton, {
		...others,
		unstyled,
		variant,
		disabled,
		mod: [{ disabled: disabled || dataDisabled }, mod],
		...getStyles("root", {
			variant,
			active: !disabled && !dataDisabled
		}),
		children: [icon || /* @__PURE__ */ jsx(CloseIcon, {}), children]
	});
});
CloseButton.classes = CloseButton_module_default;
CloseButton.varsResolver = varsResolver;
CloseButton.displayName = "@mantine/core/CloseButton";
//#endregion
export { CloseButton };

//# sourceMappingURL=CloseButton.mjs.map